// Yotpo tile fallback v3: paints tile star callouts from preloaded_bottomline
// (JSON) or simple reviews_count/reviews_average attributes.
//
// v3 adds a MutationObserver so the callout is re-painted after the theme's
// <facet-link> AJAX reload (pagination / filtering) swaps the product grid.
// Without this, tiles injected after the initial load stay blank because the
// original load-time timers never fire again.
(function(){
  var observer = null;
  var debounceTimer = null;

  function paint() {
    var divs = document.querySelectorAll('div.yotpo.bottomLine');
    divs.forEach(function(d){
      // Skip if Yotpo (or a previous paint) already filled it
      if (d.children.length > 0 && d.innerHTML.replace(/\s/g,'').length > 0) return;
      var total = 0, avg = 0;
      // Try preloaded_bottomline first
      var pb = d.getAttribute('data-yotpo-pb');
      if (pb) {
        try {
          var data = JSON.parse(pb);
          var bl = data.bottomline || {};
          total = parseInt(bl.totalReviews) || 0;
          avg = parseFloat(bl.averageScore) || 0;
        } catch(e) {}
      }
      // Fallback to simple count/avg attrs
      if (total === 0) {
        var ct = d.getAttribute('data-yotpo-count');
        var av = d.getAttribute('data-yotpo-avg');
        if (ct) total = parseInt(ct) || 0;
        if (av) avg = parseFloat(av) || 0;
      }
      if (total === 0) return;
      var avgRounded = Math.round(avg);
      var stars = '';
      for (var i = 1; i <= 5; i++) {
        stars += '<span style="color:' + (i <= avgRounded ? '#000' : '#ccc') + ';font-size:14px;line-height:1;">★</span>';
      }
      d.innerHTML = '<div class="yotpo-tile-fallback" style="display:inline-flex;align-items:center;gap:4px;font-size:13px;color:#000;margin-top:4px;line-height:1;">' + stars + '<span style="margin-left:4px;font-weight:400;">' + total + ' ' + (total === 1 ? 'Review' : 'Reviews') + '</span></div>';
    });
  }

  // Paint with the observer temporarily disconnected so our own innerHTML
  // writes don't retrigger the observer (prevents a feedback loop).
  function paintSafely() {
    if (observer) observer.disconnect();
    try { paint(); }
    finally { startObserving(); }
  }

  function scheduleRepaint() {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(paintSafely, 150);
  }

  function startObserving() {
    if (observer && document.body) {
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  // Initial paint on load (unchanged timing).
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){ setTimeout(paintSafely, 1500); });
  } else {
    setTimeout(paintSafely, 1500);
  }
  setTimeout(paintSafely, 4000);

  // Re-paint whenever new tiles are injected (e.g. <facet-link> pagination
  // and filtering swap the <product-list> HTML without a full page load).
  if ('MutationObserver' in window) {
    observer = new MutationObserver(function(mutations){
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (!node || node.nodeType !== 1) continue; // elements only
          if (
            (node.matches && node.matches('div.yotpo.bottomLine')) ||
            (node.querySelector && node.querySelector('div.yotpo.bottomLine'))
          ) {
            scheduleRepaint();
            return;
          }
        }
      }
    });
    if (document.body) startObserving();
    else document.addEventListener('DOMContentLoaded', startObserving);
  }
})();
